// Module
var code = `
<div class="position-info">
    <div class="position-info-label">
        <terceraLabel text="{{.positionIdText}}" />
        <terceraLabel text="{{.positionId}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.symbolText}}" />
        <terceraLabel text="{{.InstrumentName}}" />
    </div>
    {{#.showRoute}}
    <div class="position-info-label">
        <terceraLabel text="{{.routeText}}" />
        <terceraLabel text="{{.Route}}" />
    </div>
    {{/}}
    <div class="position-info-label">
        <terceraLabel text="{{.sideText}}" />
        <terceraLabel text="{{.OperationType}}" additionalClass="{{.sideStyle}}" />
    </div>
    {{#.leverage}} 
        <div class="position-info-label">
            <terceraLabel text="{{.leverageText}}" />
            <terceraLabel text="{{.leverage}}" />
        </div>
    {{/}}
    {{#.showProductType}}
    <div class="position-info-label">
        <terceraLabel text="{{.productTypeText}}" />
        <terceraLabel text="{{.productType}}" />
    </div>
    {{/}}
    <div class="position-info-label">
        <terceraLabel text="{{.quantityText}}" />
        <terceraLabel text="{{.AmountToClose}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.orderTypeText}}" />
        <terceraLabel text="{{.OrderType}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.openPriceText}}" />
        <terceraLabel text="{{.OpenPrice}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.currentPriceText}}" />
        <terceraLabel text="{{.CurrentPrice}}" additionalClass="{{.sideStyle}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.grossPLText}}" />
        <terceraLabel text="{{.CloseGrossPL}}" additionalClass="{{.grossPLStyle}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.accountText}}" />
        <terceraLabel text="{{.AccountName}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{.dateTimeText}}" />
        <terceraLabel text="{{.Time}}" />
    </div>
    {{#.TotalFee}}
    <div class="position-info-label">
        <terceraLabel text="{{.totalFeeText}}" />
        <terceraLabel text="{{.TotalFee}}" />
    </div>
    {{/}}
</div>


<terceraSeparator />
{{#if partialCloseAllowed}}
<div class="position-controls-container">
    <div class="position-controls">

        <div class="numeric-close-position-screen">
            <terceraLabel text="{{.quantityText}}" />

            <terceraNumeric parentContainerControl="{{parentContainerControl}}"
                            value="{{.AmountToClose}}"
                            minValue="{{.minAmountToClose}}"
                            maxValue="{{.maxAmountToClose}}"
                            step="{{.lotStep}}"
                            decimalPrecision="{{.amountPrec}}"
                            SkipValidationForMaxValue="{{SkipValidationForMaxValue}}"
                            validationStateInfo="{{.numericsErrors.n1}}"
                            enabled="{{.allowAmountEdit}}"
                            tradingNumeric="true" />
        </div>

        {{#if isVisibleOTHTrading}}
            <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                            textKey="{{overnightExecutionTextKey}}" 
                                            tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                            controlWidth="200" 
                                            events="{{isAllowOTHTradingEvents}}"/>
        {{/if}}

        <div class="errorMode-close-position-screen" style="{{^.errorMode}}display:none;{{/}}">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#menuError"></use>
            </svg>
            <terceraLabel name="errorTextLabel" text="{{.errorText}}" />
        </div>

        <div class="errorMode-close-position-screen" style="{{^.warningText}}display:none;{{/}}">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#menuError"></use>
            </svg>
            <terceraLabel name="warningTextLabel" text="{{.warningText}}" />
        </div>

        {{#additionalInfo}}
        <div id="feeInfoLabelID" class="confirmFeeInfoContainer">
            <div id="feeInfoLabel" class="confirmFeeInfoLabel">
                {{{additionalInfo}}}
            </div>
        </div>
        {{/}}
    </div>
</div>

<terceraSeparator />
{{/if}}`;
// Exports
export default code;